// The ONE "what do we call this upload on screen" helper.
//
// A Gmail thread is stored as "<subject> [<thread_id>].json", so the raw
// ``original_name`` shows an operator a filename they never chose plus an
// opaque id. Every surface that lists uploads strips it back to the subject;
// this had drifted into three separate copies of the same regex (the Gmail
// tree's row and its subject sort key, plus the failed-extractions panel), so a
// fourth caller would have been a fourth copy.
export function displayUploadName(originalName: string): string {
  return originalName.replace(/\s\[[^\]]+\]\.json$/, "");
}
